import md5 from 'blueimp-md5';

const constitutionRanges = {
    "平和": {yin: [60, 80], yang: [60, 80]},
    "气虚": {yin: [60, 80], yang: [30, 60]},
    "气虚(脾气虚证)": {yin: [60, 80], yang: [30, 60]},
    "气虚湿热": {yin: [60, 80], yang: [[30, 60], [80, 100]]},
    "气虚痰湿": {yin: [60, 80], yang: [30, 60]},
    "气虚痰湿夹瘀": {yin: [60, 80], yang: [30, 60]},
    "湿热": {yin: [60, 80], yang: [80, 100]},
    "湿热血瘀": {yin: [60, 80], yang: [[60, 80], [80, 100]]},
    "痰湿": {yin: [60, 80], yang: [30, 60]},
    "痰瘀互结": {yin: [60, 80], yang: [[30, 60], [80, 100]]},
    "瘀热互结": {yin: [60, 80], yang: [80, 100]},
    "血瘀": {yin: [60, 80], yang: [[60, 80], [80, 100]]},
    "表热里寒": {yin: [60, 80], yang: {biao: [80, 100], li: [30, 60]}},
    "表热里寒夹瘀": {yin: [60, 80], yang: {biao: [80, 100], li: [30, 60]}},
    "阴虚": {yin: [0, 30], yang: [[60, 80], [80, 100]]},
    "阴虚湿热": {yin: [0, 30], yang: [80, 100]},
    "阴虚痰湿": {yin: [0, 30], yang: [60, 80]},
    "阴虚痰湿夹瘀": {yin: [0, 30], yang: [[60, 80], [80, 100]]},
    "阳虚湿热夹瘀": {yin: [60, 80], yang: [30, 60]},
    "气血两虚夹瘀": {yin: [30, 50], yang: [30, 50]},
    "气虚湿热夹瘀": {yin: [40, 60], yang: [60, 80]},
    "实热": {yin: [50, 60], yang: [80, 100]},
    "气血两虚": {yin: [30, 40], yang: [30, 40]},
    "阴虚阳亢": {yin: [20, 40], yang: [60, 70]},
    "气虚血瘀": {yin: [40, 50], yang: [30, 50]},
    "阴虚血瘀": {yin: [20, 40], yang: [50, 60]},
    "阴虚阳亢夹瘀": {yin: [10, 30], yang: [60, 80]},
    "血虚": {yin: [30, 40], yang: [50]},
}

function getScoreFromRange(id, type, key, range) {
    const hash = md5(`${id}-${type}-${key}`);
    const num = parseInt(hash.slice(0, 8), 16);
    const percent = (num % 10000) / 10000;

    return Math.round(range[0] + (range[1] - range[0]) * percent);
}

function getScoreFromMultiRange(id, type, key, ranges) {
    const hash = md5(`${id}-${type}-${key}`);
    const num = parseInt(hash.slice(0, 8), 16);
    const percent = (num % 10000) / 10000;

    const pick = percent < 0.5 ? ranges[0] : ranges[1];
    const scaledPercent = percent < 0.5 ? percent * 2 : (percent - 0.5) * 2;
    return Math.round(pick[0] + (pick[1] - pick[0]) * scaledPercent);
}

function getBiaoLiScore(id, type, yangRange) {
    const biao = getScoreFromRange(id, type, 'biao', yangRange.biao);
    const li = getScoreFromRange(id, type, 'li', yangRange.li);
    // return {biao, li};
    return biao;
}

export function getFixedConstitutionScore(id, type) {
    const range = constitutionRanges[type];
    if (!range) return {error: `未知体质类型：${type}`};

    const yin = Array.isArray(range.yin)
        ? getScoreFromRange(id, type, 'yin', range.yin)
        : null;

    let yang;
    if (Array.isArray(range.yang[0])) {
        // 多区间
        yang = getScoreFromMultiRange(id, type, 'yang', range.yang);
    } else if (Array.isArray(range.yang)) {
        // 单区间
        yang = getScoreFromRange(id, type, 'yang', range.yang);
    } else if (typeof range.yang === 'object') {
        // 表里分开
        yang = getBiaoLiScore(id, type, range.yang);
    }

    return {
        id,
        type,
        yin,
        yang
    };
}
